import axios from "axios";
// Importamos el archivo con las propiedades globales
import store from "../../../store.js";

export default {
    /**
     * It takes a data object as a parameter, and returns a promise that resolves to the data returned
     * by the API, or rejects with an error
     * @param data - The data to be sent to the server.
     * @returns A promise.
     */
    post(data) {
        const API = `/api/payment/SavePayment`;

        return new Promise((resolve, reject) => {
            axios
                .post(API, data)
                .then((res) => {
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    /**
     * The function clears the shopping cart by dispatching the clearShoppingCart action to the store
     */
    clearShoppingCart() {
        store.dispatch("clearShoppingCart");
    },
    orderErrorCatch() {
        Vue.$toast.open({
            message: this.$t("paypal.create_order_error"),
            type: "error",
        });
    },
};